// extracted by mini-css-extract-plugin
module.exports = {"span":"span___239_b","second":"second___d9Drs","title":"title___3N48h"};